<template>
  <div>
    <b-card-text style="overflow-y: auto; height: 222px" class="px-3">
      <div :key="project.id" v-for="project in projects.slice(0, 3)" class="row m-b-30">
        <div class="col-auto p-r-0">
          <img src="https://gazovik-neft.ru/assets/images/rvs_news.png" class="img-radius img-40 align-top m-r-15" />
        </div>
        <div class="col">
          <h6 class="m-b-5">
            {{ project.name }}
            <span class="text-muted f-right f-13"><b-btn :to="'/category/' + project.id">Перейти</b-btn></span>
          </h6>
          <p class="text-muted m-b-0">
            <b-badge v-if="project.status == 0">Не рассчитан</b-badge>
            <b-badge v-if="project.status == 1" variant="primary">В процессе расчета</b-badge>
            <b-badge v-if="project.status == 3" variant="danger">Возникли ошибки</b-badge>
            <b-badge v-if="project.status == 2" variant="success">Рассчитан</b-badge>
          </p>
        </div>
      </div>
    </b-card-text>
    <div class="card-footer p-0">
      <div class="text-center">
        <a href="#!" v-b-modal.modal-category-projects class="b-b-primary text-primary">Посмотреть все проекты</a
        >&nbsp;&nbsp;
        <b-btn v-b-modal.modal-category variant="primary" href="#!">Новый проект</b-btn>
      </div>
    </div>
    <b-modal id="modal-category-projects" size="lg" hide-footer title="Проекты">
      <projects :projects="projects"></projects>
    </b-modal>
    <!-- Modal Component -->
    <b-modal id="modal-category" ref="new_project" hide-footer title="Новый проект">
      <newBuilding v-on:create="add"></newBuilding>
    </b-modal>

    <!-- Modal Component -->
    <b-modal id="modal-agreement" size="xl" hide-footer title="Пользовательское соглашение">
      <agreement></agreement>
    </b-modal>
    <!-- TODO: Удалить, если нигде не вылезет багов, модалка-дубль с одинаком id  -->
    <!-- <b-modal id="modal-settings" size="xl" hide-footer title="Настройка профиля">
      <settings></settings>
    </b-modal> -->
    <!-- Modal Component -->
    <b-modal id="modal-news-add" size="xl" hide-footer title="Добавить новость">
      <newsAdd></newsAdd>
    </b-modal>
  </div>
</template>
<style>
fieldset {
  border: unset !important;
}
</style>
<script>
import newBuilding from "./new_building";
import projects from "./Projects";
export default {
  name: "Risk",
  data() {
    return {
      projects: [],
    };
  },
  components: {
    newBuilding,
    projects,
  },
  created() {
    this.fetchData();
  },
  methods: {
    add(model) {
      this.projects.unshift(model);
      this.$refs.new_project.hide();
      this.$parent.$router.push("/category/" + model.id);
    },
    fetchData() {
      this.loading = true;
      this.$http
        .get("category/buildings/get")
        .then((response) => {
          this.projectsLoading = false;
          // JSON responses are automatically parsed.
          this.projects = response.data;
          this.loading = false;
        })
        .catch(() => {});
    },
  },
};
</script>
